module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lightbox', {
    attrs: {
      "showing": _vm.showing
    },
    on: {
      "update:showing": function($event) {
        _vm.emitShowing($event)
      },
      "close": function($event) {
        _vm.emitClose()
      }
    }
  }, [_c('swiper', {
    ref: "swiper",
    staticClass: "swiper",
    attrs: {
      "options": _vm.swiperOptions
    },
    on: {
      "slide-change": function($event) {
        _vm.onSlideChange()
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('template', {
    attrs: {
      "slot": "decorations"
    },
    slot: "decorations"
  }, [_c('button', {
    staticClass: "swiper-button-prev swiper-button-white",
    attrs: {
      "type": "button",
      "disabled": !_vm.showSlideToPrev
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.slideToPrev()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "swiper-button-next swiper-button-white",
    attrs: {
      "type": "button",
      "disabled": !_vm.showSlideToNext
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.slideToNext()
      }
    }
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f392142!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/lightbox/gallery.vue
// module id = 1983
// module chunks = 2